import { Button, Drawer, Modal, Steps, Table, Typography } from "antd";
import axios from "axios";
import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
// import { UserInfo } from "../../../../context";
import { useReactToPrint } from "react-to-print";
import { PrinterOutlined, FormOutlined, CarOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { NotificationInfo } from "../../../../context";
import moment from "moment";
// import { UserInfo } from "../../../context";

const MyProcessPODetails = ({ open, close, selectedData }) => {
  //   const { userData } = useContext(UserInfo);
  const scroll = {};
  const [orderDetailsList, setOrderDetailsList] = useState({
    data: [],
    ready: false,
  });
  const tableLayout = "";
  const componentRef = useRef();
  const [paddingPrint, setPaddingPrint] = useState(0);
  const [displayDetailsPrint, setDisplayDetailsPrint] = useState(false);
  const navigate = useNavigate();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [inTransitDialog, setInTransitDialog] = useState(false);
  const { rerunNotif } = useContext(NotificationInfo);

  const tableProps = {
    bordered: false,
    size: "medium",
    // expandable,
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Product",
      dataIndex: ["pounsaverawproduct", "product"],
    },
    {
      title: "Description",
      dataIndex: ["pounsaverawproduct", "description"],
    },
    {
      title: "Unit",
      dataIndex: ["pounsaverawproduct", "rawproductsuserunit", "unit"],
      align: "right",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      align: "right",
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  //   console.log("selectedData", selectedData);

  const getMerchantInvoiceDetails = useCallback(() => {
    var params = {
      po_number_id: selectedData !== null ? selectedData.po_number_id : "",
    };
    axios
      .get("user/commissary-employee/spec-po-info", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setOrderDetailsList({ data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [selectedData]);

  useEffect(() => {
    getMerchantInvoiceDetails();
  }, [getMerchantInvoiceDetails]);

  const handleOk = () => {
    setConfirmLoading(true);
    setTimeout(() => {
      setInTransitDialog(false);
      setConfirmLoading(false);
      handleUpdateStatusIntoInTransit();
    }, 2000);
  };

  const handleUpdateStatusIntoInTransit = () => {
    const formdata = new FormData();
    formdata.append(
      "po_number_id",
      orderDetailsList.data.length > 0 && orderDetailsList.data[0].po_number_id
    );
    // setLoadings(true);
    axios
      .post("user/commissary-employee/update-po-into-in-transit", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Update purchase order successfully.");
          setTimeout(() => {
            // setLoadings(false);
            getMerchantInvoiceDetails();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        // setLoadings(false);
      });
  };

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,

    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        setPaddingPrint(10);
        setDisplayDetailsPrint(true);
        resolve();
      });
    },
    onAfterPrint: () => {
      setPaddingPrint(0);
      setDisplayDetailsPrint(false);
    },
  });

  return (
    <Drawer
      title="Purchase Order Details"
      width={window.innerWidth > 710 ? 710 : "100vw"}
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <>
          <div
            style={{
              marginBottom: 10,
              border: "1px solid #e5e5e5",
              borderStyle: "dashed",
              paddingTop: 10,
              paddingBottom: 10,
              paddingLeft: 5,
              paddingRight: 5,
            }}
          >
            <Steps
              labelPlacement="vertical"
              size="small"
              direction={window.innerWidth > 710 ? "horizontal" : "vertical"}
              items={[
                {
                  title: "Acknowledge",
                  status:
                    orderDetailsList.data.length > 0 &&
                    orderDetailsList.data[0].acknowledge_datetime !== null
                      ? "finish"
                      : "wait",
                  // icon: <DeleteOutlined />,
                },
                {
                  title: "Preparing",
                  status:
                    orderDetailsList.data.length > 0 &&
                    orderDetailsList.data[0].preparing_datetime !== null
                      ? "finish"
                      : // : orderDetailsList.data.length > 0 &&
                        //   orderDetailsList.data[0].acknowledge_datetime !== null
                        // ? "process"
                        "wait",
                  // icon: <DeleteOutlined />,
                },
                {
                  title: "Ready",
                  status:
                    orderDetailsList.data.length > 0 &&
                    orderDetailsList.data[0].ready_datetime !== null
                      ? "finish"
                      : // : orderDetailsList.data.length > 0 &&
                        //   orderDetailsList.data[0].preparing_datetime !== null
                        // ? "process"
                        "wait",
                  // icon: <DeleteOutlined />,
                },
                {
                  title: "In-Transit",
                  status:
                    orderDetailsList.data.length > 0 &&
                    orderDetailsList.data[0].intransit_datetime !== null
                      ? "finish"
                      : // : orderDetailsList.data.length > 0 &&
                        //   orderDetailsList.data[0].ready_datetime !== null
                        // ? "process"
                        "wait",
                  // icon: <DeleteOutlined />,
                },
                {
                  title: "Arrived",
                  status:
                    orderDetailsList.data.length > 0 &&
                    orderDetailsList.data[0].arrived_datetime !== null
                      ? "finish"
                      : // : orderDetailsList.data.length > 0 &&
                        //   orderDetailsList.data[0].intransit_datetime !== null
                        // ? "process"
                        "wait",
                  // icon: <DeleteOutlined />,
                },
                {
                  title: "Complete",
                  status:
                    orderDetailsList.data.length > 0 &&
                    orderDetailsList.data[0].complete_datetime !== null
                      ? "finish"
                      : // : orderDetailsList.data.length > 0 &&
                        //   orderDetailsList.data[0].arrived_datetime !== null
                        // ? "process"
                        "wait",

                  // "wait"
                  // icon: <DeleteOutlined />,
                },
              ]}
            />
          </div>

          <div style={{ marginBottom: 10 }}>
            <Typography>
              <span style={{ fontSize: 12 }}>Acknowledge by: </span>
              <span style={{ fontSize: 12, fontWeight: "bold" }}>
                {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].acknowledge_by !== null
                  ? `${orderDetailsList.data[0].rawprodpocomemployee.firstname} ${orderDetailsList.data[0].rawprodpocomemployee.lastname}`
                  : "Commissary"}
              </span>
            </Typography>
            <Typography>
              <span style={{ fontSize: 12 }}>Acknowledge date: </span>
              <span style={{ fontSize: 12, fontWeight: "bold" }}>
                {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].acknowledge_datetime !== null
                  ? moment(
                      new Date(orderDetailsList.data[0].acknowledge_datetime),
                      "YYYY-MM-DD"
                    ).format("LLL")
                  : ""}
              </span>
            </Typography>
            <Typography>
              <span style={{ fontSize: 12 }}>Prepared date: </span>
              <span style={{ fontSize: 12, fontWeight: "bold" }}>
                {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].preparing_datetime !== null
                  ? moment(
                      new Date(orderDetailsList.data[0].preparing_datetime),
                      "YYYY-MM-DD"
                    ).format("LLL")
                  : ""}
              </span>
            </Typography>
            <Typography>
              <span style={{ fontSize: 12 }}>Ready date: </span>
              <span style={{ fontSize: 12, fontWeight: "bold" }}>
                {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].ready_datetime !== null
                  ? moment(
                      new Date(orderDetailsList.data[0].ready_datetime),
                      "YYYY-MM-DD"
                    ).format("LLL")
                  : ""}
              </span>
            </Typography>
            <Typography>
              <span style={{ fontSize: 12 }}>In-Transit date: </span>
              <span style={{ fontSize: 12, fontWeight: "bold" }}>
                {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].intransit_datetime
                  ? moment(
                      new Date(orderDetailsList.data[0].intransit_datetime),
                      "YYYY-MM-DD"
                    ).format("LLL")
                  : ""}
              </span>
            </Typography>
            <Typography>
              <span style={{ fontSize: 12 }}>Arrived date: </span>
              <span style={{ fontSize: 12, fontWeight: "bold" }}>
                {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].arrived_datetime
                  ? moment(
                      new Date(orderDetailsList.data[0].arrived_datetime),
                      "YYYY-MM-DD"
                    ).format("LLL")
                  : ""}
              </span>
            </Typography>
            <Typography>
              <span style={{ fontSize: 12 }}>Completed date: </span>
              <span style={{ fontSize: 12, fontWeight: "bold" }}>
                {orderDetailsList.data.length > 0 &&
                orderDetailsList.data[0].complete_datetime
                  ? moment(
                      new Date(orderDetailsList.data[0].complete_datetime),
                      "YYYY-MM-DD"
                    ).format("LLL")
                  : ""}
              </span>
            </Typography>
          </div>

          <div
            style={{ overflowX: "auto", padding: paddingPrint }}
            ref={componentRef}
          >
            {displayDetailsPrint && (
              <Typography.Title level={4} style={{ marginBottom: 15 }}>
                {selectedData.po_number} - Purchase Order
              </Typography.Title>
            )}
            <Table
              {...tableProps}
              // pagination={{
              //   position: ["bottomRight"],
              // }}
              pagination={false}
              columns={tableColumns}
              dataSource={
                orderDetailsList.data.length > 0 ? orderDetailsList.data : []
              }
              scroll={scroll}
              rowKey={(record) => record.raw_id}
            />
          </div>
        </>
      )}

      <div style={{ display: "flex", marginTop: 10 }}>
        <div style={{ flexGrow: 1 }} />
        <div>
          <Button
            type="primary"
            onClick={handlePrint}
            icon={<PrinterOutlined />}
            style={{ marginRight: 10 }}
          >
            Print
          </Button>
        </div>

        {/* {console.log(
          "orderDetailsList",
          orderDetailsList.data.length > 0 && orderDetailsList.data[0]
        )} */}

        {orderDetailsList.data.length > 0 &&
          orderDetailsList.data[0].po_status === "acknowledge" && (
            <div>
              <Button
                type="primary"
                onClick={() =>
                  navigate(
                    `/po-my-process/${orderDetailsList.data[0].po_number_id}/${orderDetailsList.data[0].po_number}/${orderDetailsList.data[0].user_id}`
                  )
                }
                icon={<FormOutlined />}
              >
                Prepare
              </Button>
            </div>
          )}

        {orderDetailsList.data.length > 0 &&
          orderDetailsList.data[0].po_status === "preparing" && (
            <div>
              <Button
                type="primary"
                onClick={() =>
                  navigate(
                    `/po-my-process/${orderDetailsList.data[0].po_number_id}/${orderDetailsList.data[0].po_number}/${orderDetailsList.data[0].user_id}`
                  )
                }
                icon={<FormOutlined />}
              >
                Prepare
              </Button>
            </div>
          )}

        {/* {(orderDetailsList.data.length > 0 &&
          orderDetailsList.data[0].po_status === "acknowledge") ||
          (orderDetailsList.data.length > 0 &&
            orderDetailsList.data[0].po_status === "preparing" && (
              <div>
                <Button
                  type="primary"
                  onClick={() =>
                    navigate(
                      `/po-my-process/${orderDetailsList.data[0].po_number_id}/${orderDetailsList.data[0].po_number}/${orderDetailsList.data[0].user_id}`
                    )
                  }
                  icon={<FormOutlined />}
                >
                  Prepare
                </Button>
              </div>
            ))} */}

        {orderDetailsList.data.length > 0 &&
          orderDetailsList.data[0].po_status === "ready" && (
            <div>
              <Button
                type="primary"
                onClick={() => {
                  setInTransitDialog(true);
                }}
                icon={<CarOutlined />}
              >
                Set Status In Transit
              </Button>
            </div>
          )}
      </div>

      <Modal
        title="Are you sure to set status into in transit?"
        open={inTransitDialog}
        onOk={handleOk}
        confirmLoading={confirmLoading}
        onCancel={() => setInTransitDialog(false)}
      />
    </Drawer>
  );
};

export default MyProcessPODetails;
